import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Input } from 'semantic-ui-react';

class Title extends React.Component {

  state = {
    open: false
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit() {
    let context = this;
    let voucherno = context.state.voucherno;
    let requestid = this.props.requestid;
    $.ajax({
      type: 'POST',
      data: { 'id': requestid, 'voucher': voucherno },
      url: Server() + 'purchaserequest/updatevoucher.php',
      success: function(data)
      {
        if (data == 1) {
          let datas = context.props.data;
          datas.map((x) => {
            if (x.id == requestid) {
              x.voucher_no = voucherno;
            }
          })
          context.setState({ open: false })
          context.props.update(datas);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    })
  }

  render() {
    return (
      <div>
        <div style={{cursor: 'pointer'}}
        onClick={ () => { this.setState({ open: true, voucherno: this.props.voucherno }) }}>
              {this.props.voucherno}
        </div>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth1}  open={this.state.open}
            onClose={ () => { this.setState({ open: false }) }}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Voucher Number</DialogTitle>
            <DialogContent>
              <Input type="number" value={this.state.voucherno} placeholder='Point'
              onChange={this.handleChange('voucherno')} />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.submit.bind(this)}>Submit</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Title;
